document.addEventListener('DOMContentLoaded', function () {
  const container = document.getElementById('infinite-blog');
  if (!container) return;

  let page = 1;
  let isLoading = false;
  const blog = container.dataset.blog;
  const postsPerLoad = parseInt(container.dataset.postsPerLoad);
  const loadingIndicator = document.getElementById('loading');

  const loadMorePosts = () => {
    if (isLoading) return;
    isLoading = true;
    loadingIndicator.style.display = 'block';

    fetch(`/blogs/${blog}?view=infinite-scroll&page=${page + 1}`)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newPosts = doc.getElementById('blog-posts');

        if (newPosts && newPosts.innerHTML.trim()) {
          document.getElementById('blog-posts').insertAdjacentHTML('beforeend', newPosts.innerHTML);
          page++;
          isLoading = false;
          loadingIndicator.style.display = 'none';
        } else {
          loadingIndicator.innerText = 'No more posts.';
        }
      });
  };

  window.addEventListener('scroll', () => {
    if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 500) {
      loadMorePosts();
    }
  });
});